export enum EventMessageTypes {
  REFETCH = 'REFETCH',
  CONFIRM_REFETCH = 'CONFIRM_REFETCH',
  SEARCH = 'SEARCH',
  FILTER = 'FILTER',
  FILTER_RESET = 'FILTER_RESET',
  NONE = '',
}
